import { InputNumber } from "antd";
import { CSSProperties } from "react";

export interface IPriceInput {
    style?: CSSProperties;
    defaultValue?: any;
    onChange?: (value: any) => void;
    placeholder?: string;
    disabled?: boolean;
    value?: any;
}

export const PriceInput = (props: IPriceInput) => {

    return (
        <InputNumber
            id={(props as any).key}
            formatter={value => {
                return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }}
            parser={value => {
                return value?.replace(/\\s?|(,*)/g, '') ?? "";
            }}
            style={props.style}
            onKeyPress={(event) => {
                if (event.charCode < 48 || event.charCode > 57) {
                    event.preventDefault();
                }
            }}
            defaultValue={props.defaultValue}
            type={"text"}
            onChange={props.onChange}
            placeholder={props.placeholder}
            disabled={props.disabled}
            value={props.value}
            prefix={<span> ریال </span>}
        />
    );
}